import { register } from "@shopify/theme-sections";

const selectors = {
	monogramPositionContainer:
		".customizable-product-fields__monogram-position",
	monogramInputContainer: ".customizable-product-fields__monogram-field",
	monogramFontContainer: ".customizable-product-fields__choose-font",
	monogramColorContainer: ".customizable-product-fields__color-block",
	colorRadioButton: "[data-color-radio-input]",
	fontRadioButton: "[data-font-radio-input]",
	addToCartButton: "[data-product-add-to-card-btn]",
	counter: {
		container: "[data-customizable-product-counter]",
		input: "[data-customizable-product-counter-input]",
		incrementBtn: "[data-customizable-product-counter-increment]",
		decrementBtn: "[data-customizable-product-counter-decrement]",
		formInput: "[data-customizable-product-quantity]"
	},
	productForm: "[data-product-form]",
	formSelector: "#customizable-select"
};

register("customizable-product", {
	counterInput: document.querySelector(selectors.counter.input),
	formCounterInput: document.querySelector(selectors.counter.formInput),
	incrementButton: document.querySelector(selectors.counter.incrementBtn),
	decrementButton: document.querySelector(selectors.counter.decrementBtn),
	currentVariantAvailable: 999,
	onLoad: function () {
		//Check radio change
		this.onRadioChange();
		//Quantity selector input and buttons
		this.onChangeInput();
		this.onIncrement();
		this.onDecrement();
		//Re-init form quantity input after back to cashed page
		if (this.counterInput != null) {
			this.onQuantityChange(this.counterInput.value);
		}
	},
	getColorName(container) {
		const colorVariantsContainer = document.querySelector(container);
		if (colorVariantsContainer != null) {
			return colorVariantsContainer
				.querySelector('.color-variant input[type="radio"]:checked')
				.getAttribute("data-color-name");
		}
	},
	setVariant() {
		const currentColor = this.getColorName(
			selectors.monogramColorContainer
		).toLowerCase();
		const currentFont = this.getActiveRadioButton(
			selectors.monogramFontContainer
		).toLowerCase();
		const formSelector = document.querySelector(selectors.formSelector);
		const getSelectorOptions = formSelector.querySelectorAll("option");
		getSelectorOptions.forEach(function (item) {
			const optionContent = item.innerText.toLowerCase();
			if (
				optionContent.includes(currentColor) &&
				optionContent.includes(currentFont)
			) {
				formSelector
					.querySelector(`option[selected="true"]`)
					.removeAttribute("selected");
				formSelector
					.querySelector(`option[value="${item.value}"]`)
					.setAttribute("selected", true);
			}
		});
	},
	getMonogramText(container) {
		const monogramInputContainer = document.querySelector(container);
		if (monogramInputContainer != null) {
			return monogramInputContainer.querySelector('input[type="text"]')
				.value;
		}
	},
	getActiveRadioButton(container) {
		const radioContainer = document.querySelector(container);
		if (radioContainer != null) {
			return radioContainer.querySelector(
				'.radio--wrapper input[type="radio"]:checked'
			).value;
		}
	},
	onQuantityChange: function (value) {
		this.formCounterInput.value = value;
	},
	onChangeInput: function () {
		if (this.counterInput != null) {
			this.counterInput.addEventListener("keyup", (event) => {
				let value = event.target.value;
				if (!Number.isNaN(+value)) {
					if (value.length === 0) {
						event.target.value = 1;
					} else if (+value > +this.currentVariantAvailable) {
						event.target.value = this.currentVariantAvailable;
					}
				} else {
					event.target.value = event.target.value.slice(0, -1);
				}
				this.onQuantityChange(value);
			});
		}
	},
	onIncrement: function () {
		if (this.incrementButton != null && this.counterInput != null) {
			this.incrementButton.addEventListener("click", () => {
				let currentVal = +this.counterInput.value + 1;
				this.counterInput.value = currentVal;
				this.onQuantityChange(currentVal);
			});
		}
	},
	onDecrement: function () {
		if (this.decrementButton != null && this.counterInput != null) {
			this.decrementButton.addEventListener("click", () => {
				let currentVal = this.counterInput.value;
				currentVal = currentVal > 1 ? currentVal - 1 : 1;
				this.counterInput.value = currentVal;
				this.onQuantityChange(currentVal);
			});
		}
	},
	onRadioChange() {
		const variantRadioButtons =
			selectors.colorRadioButton + ", " + selectors.fontRadioButton;
		document.querySelectorAll(variantRadioButtons).forEach((item) => {
			item.addEventListener("change", () => {
				this.setVariant();
			});
		});
	}
});
